import eventRR from "../../assets/img/events/RoyalRumble.png";
import eventEC from "../../assets/img/events/EliminationChamber.png";
import eventWM from "../../assets/img/events/Wrestlemania.png";
import eventBK from "../../assets/img/events/Backlash.png";
//import eventKOTR from '../assets/img/events/EventKOTR.png';
import eventCATC from "../../assets/img/events/Clash.png";
import eventMITB from "../../assets/img/events/MITB.png";
import eventSS from "../../assets/img/events/SummerSlam.png";
//import eventBIB from '../assets/img/events/EventBIB.png';
//import eventBB from '../assets/img/events/EventBB.png';
import eventCJ from "../../assets/img/events/CrownJewel.png";
import eventSSWG from "../../assets/img/events/SurvivorSeries.png";
import eventNOC from "../../assets/img/historicEvents/LogoNOC/2023-2026.png";
import eventSNME from "../../assets/img/historicEvents/LogoSNME/2024-2026.png";

export const events = [
  {
    id: "royal-rumble",
    name: "ROYAL RUMBLE",
    image: eventRR,
    alt: "Royal Rumble event poster",
  },
  {
    id: "elimination-chamber",
    name: "ELIMINATION CHAMBER",
    image: eventEC,
    alt: "Elimination Chamber event poster",
  },
  {
    id: "wrestlemania",
    name: "WRESTLEMANIA",
    image: eventWM,
    alt: "WrestleMania event poster",
  },
  {
    id: "backlash",
    name: "BACKLASH",
    image: eventBK,
    alt: "Backlash event poster",
  },
  /*{
    id: 'kotr',
    name: 'KING AND QUEEN OF THE RING',
    image: eventKOTR,
    alt: 'King and Queen of the Ring event poster',
  },*/
  {
    id: "catc",
    name: "CLASH AT THE CASTLE",
    image: eventCATC,
    alt: "Clash at the Castle event poster",
  },
  {
    id: "night-of-champions",
    name: "NIGHT OF CHAMPIONS",
    image: eventNOC,
    alt: "Night of Champions event poster",
  },
  {
    id: "mitb",
    name: "MONEY IN THE BANK",
    image: eventMITB,
    alt: "Money in the Bank event poster",
  },
  {
    id: "summerslam",
    name: "SUMMERSLAM",
    image: eventSS,
    alt: "SummerSlam event poster",
  },
  {
    id: "saturday-nights-main-event",
    name: "SATURDAY NIGHT'S MAIN EVENT",
    image: eventSNME,
    alt: "Saturday Night's Main Event event poster",
  },
  /*{ id: 'bash-berlin', 
    name: 'BASH IN BERLIN', 
    image: eventBIB, 
    alt: 'Bash in Berlin event poster' 
  },
  { id: 'bad-blood', 
    name: 'BAD BLOOD', 
    image: eventBB, 
    alt: 'Bad Blood event poster' 
  },*/
  {
    id: "crown-jewel",
    name: "CROWN JEWEL",
    image: eventCJ,
    alt: "Crown Jewel event poster",
  },
  {
    id: "survivor-series",
    name: "SURVIVOR SERIES",
    image: eventSSWG,
    alt: "Survivor Series event poster",
  },
];
